import script from "./zone-mgmt-detail.vue?vue&type=script&lang=tsx&setup=true"
export * from "./zone-mgmt-detail.vue?vue&type=script&lang=tsx&setup=true"

import "./zone-mgmt-detail.vue?vue&type=style&index=0&id=dc8dedca&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc8dedca"]])

export default __exports__